export default __webpack_public_path__ + "static/media/chevron-left.a650feca.svg";